<div class="modal-prompt-save">
  <kmd-modal id="{{id}}" modalSize="large" headline="Save prompt">
    <app-form-prompt [prompt]="prompt!" (formAcceptEvent)="onFormAccept($event)"/>
  </kmd-modal>
  
  <kmd-alerts kmd-error [(show)]="showAlert" alertText="The prompt could not be saved. There was a problem contacting the server." [dismissible]="true"></kmd-alerts>
</div>

